export const ASSET_STATUS_MISSING_INFO = 1;
export const ASSET_STATUS_INFO_COMPLETE = 2;
export const ASSET_STATUS_CONTRACT_READY = 5;
export const ASSET_STATUS_CONTRACTED = 6;
export const ASSET_STATUS_DELETED = 8;
export const ASSET_STATUS_LOT_PULLED = 9;
export const ASSET_STATUS_SYNCED_UNSIGNED = 21;
export const ASSET_STATUS_SYNCED_SIGNED = 22;
export const ASSET_STATUS_SELLING = 31;
export const ASSET_STATUS_NOT_SOLD = 38;
export const ASSET_STATUS_SOLD = 50;
export const ASSET_STATUS_BUYER_ABANDONED = 75;
export const ASSET_STATUS_COLLAPSED_TO_SELLER = 89;
export const ASSET_STATUS_COLLAPSED_TO_INVENTORY = 93;
export const ASSET_STATUS_CLOSED = 99;

export const ASSET_STATUS_MISSING_INFO_DESC = 'Missing Info';
export const ASSET_STATUS_INFO_COMPLETE_DESC = 'Info Complete';
export const ASSET_STATUS_CONTRACT_READY_DESC = 'Contract Ready';
export const ASSET_STATUS_DELETED_DESC = 'Deleted';
export const ASSET_STATUS_SYNCED_UNSIGNED_DESC = 'Unsigned';
export const ASSET_STATUS_SYNCED_SIGNED_DESC = 'Signed';
export const ASSET_STATUS_SELLING_DESC = 'Selling';
export const ASSET_STATUS_SOLD_DESC = 'Sold';
export const ASSET_STATUS_COLLAPSED_TO_INVENTORY_DESC = 'Collapsed to Inventory';
export const ASSET_STATUS_COLLAPSED_TO_SELLER_DESC = 'Collapsed to Seller';
export const ASSET_STATUS_LOT_PULLED_DESC = 'Lot Pulled';
export const ASSET_STATUS_CONTRACTED_DESC = 'Contracted';
export const ASSET_STATUS_NOT_SOLD_DESC = 'Not Sold';
export const ASSET_STATUS_CLOSED_DESC = 'Closed';
export const ASSET_STATUS_BUYER_ABANDONED_DESC = 'Abandoned';


export const assetStatusType = [

  {
    name: ASSET_STATUS_MISSING_INFO_DESC,
    id: ASSET_STATUS_MISSING_INFO
  },
  {
    name: ASSET_STATUS_DELETED_DESC,
    id: ASSET_STATUS_DELETED
  },
  {
    name: ASSET_STATUS_INFO_COMPLETE_DESC,
    id: ASSET_STATUS_INFO_COMPLETE
  },
  {
    name: ASSET_STATUS_CONTRACT_READY_DESC,
    id: ASSET_STATUS_CONTRACT_READY
  },
  {
    name: ASSET_STATUS_SYNCED_UNSIGNED_DESC,
    id: ASSET_STATUS_SYNCED_UNSIGNED
  },
  {
    name: ASSET_STATUS_SYNCED_SIGNED_DESC,
    id: ASSET_STATUS_SYNCED_SIGNED
  },
  {
    name: ASSET_STATUS_SELLING_DESC,
    id: ASSET_STATUS_SELLING
  },
  {
    name: ASSET_STATUS_SOLD_DESC,
    id: ASSET_STATUS_SOLD
  },
  {
    name: ASSET_STATUS_COLLAPSED_TO_INVENTORY_DESC,
    id: ASSET_STATUS_COLLAPSED_TO_INVENTORY
  },
  {
    name: ASSET_STATUS_COLLAPSED_TO_SELLER_DESC,
    id: ASSET_STATUS_COLLAPSED_TO_SELLER
  },
  {
    name: ASSET_STATUS_LOT_PULLED_DESC,
    id: ASSET_STATUS_LOT_PULLED
  },
  {
    name: ASSET_STATUS_CONTRACTED_DESC,
    id: ASSET_STATUS_CONTRACTED
  },
  {
    name: ASSET_STATUS_NOT_SOLD_DESC,
    id: ASSET_STATUS_NOT_SOLD
  },
  {
    name: ASSET_STATUS_CLOSED_DESC,
    id: ASSET_STATUS_CLOSED
  },
  {
    name: ASSET_STATUS_BUYER_ABANDONED_DESC,
    id: ASSET_STATUS_BUYER_ABANDONED
  }
];

export class AssetStatus {

  public static isBelongingToPreSaleTab(statusId: number): boolean {
    return statusId === ASSET_STATUS_SYNCED_UNSIGNED || statusId === ASSET_STATUS_SYNCED_SIGNED;
  }

  public static isPostSaleStatus(statusId: number): boolean {
    return statusId === ASSET_STATUS_SOLD || statusId === ASSET_STATUS_BUYER_ABANDONED || statusId === ASSET_STATUS_COLLAPSED_TO_SELLER ||
      statusId === ASSET_STATUS_COLLAPSED_TO_INVENTORY;
  }
}
